/* @flow */

import * as React from 'react';
import {colors} from '../colors';
import type {ButtonVariant} from '../button/types';

import './button-icon.css';

export const sizes = {
    small: 'small',
    normal: 'normal',
    big: 'big',
    xlarge: 'xlarge',
};

type Props = {
    variant: ButtonVariant,
    size: $Keys<typeof sizes>,
    icon: React.ComponentType<*>,
};

export function ButtonIcon(props: Props) {
    const Icon = props.icon;

    return (
        <div styleName='button-icon'>
            <Icon
                wrapWithDiv={false}
                size={getIconSize(props.size)}
                fill={getFillColor(props.variant)}
            />
        </div>
    );
}

function getFillColor(variant: ButtonVariant) {
    switch (variant) {
        case 'primary':
        case 'orange':
        case 'save':
        case 'danger':
            return '#fff';
        case 'secondary':
            return colors.grey;
        default:
            return colors.grey;
    }
}

function getIconSize(size: $Keys<typeof sizes>) {
    switch (size) {
        case 'small':
        case 'normal':
            return 13;
        case 'big':
            return 15;
        case 'xlarge':
            return 17;
    }
}
